/*
 * @Author: Li, Yu Jia
 * @Date: 2020-02-27 15:55:30
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2021-06-18 13:51:29
 */

import React, { useEffect, useState } from 'react';
import { getHostVendorDict, getVendorDict } from '../../logics';
import { getIsNavinkPlug, getRootDir, getWebAddress } from './../../selectors';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import TopNavLink from './../TopNavLink';
import { sendBackXml } from '../../logics';
import styles from './Logo.scss';

export default function Logo({ dark, logoExt = 'svg', companyName, role = 'none' }) {
  const dispatch = useDispatch();
  const { webAddress, rootDir } = useSelector((state) => {
    return {
      rootDir: getRootDir(state) || getVendorDict('rootDir') || getHostVendorDict('rootDir'),
      webAddress: getWebAddress(state),
    };
  });
  const alt = `${companyName} logo`;
  const logoPath = rootDir && rootDir.endsWith('/') ? '' : '/';
  const logoSrcWithoutExt = `/resources/assets${rootDir}${logoPath}logo${dark ? '-dark' : ''}`;

  const [logoSrc, setLogoSrc] = useState(`${logoSrcWithoutExt}.${logoExt}`);
  const logoHref = webAddress || '#';
  const isNavInk = useSelector(getIsNavinkPlug);
  //TODO: will remove the following check if vendor.logoFilename changed in 2021.10. search this TODO comment
  const logoClickHandler = () => {
    dispatch(sendBackXml());
  };
  useEffect(() => {
    let _mount = true;
    const svgSrc = `${logoSrcWithoutExt}.svg?v=3`;
    const img = new Image();
    img.onload = () => {
      _mount && setLogoSrc(`${svgSrc}`);
    };
    img.onerror = () => {
      _mount && setLogoSrc(`${logoSrcWithoutExt}.${logoExt}`);
    };
    img.src = svgSrc;

    return () => {
      _mount = false;
    };
  }, [logoExt, logoSrcWithoutExt]);
  return (
    <>
      {rootDir && rootDir.length > 0 && (
        <div className={styles['logo']} role="none">
          {!isNavInk && webAddress ? (
            <TopNavLink id="logo" role={role} url={logoHref}>
              <img src={logoSrc} alt={alt} />
            </TopNavLink>
          ) : (
            <a href="javascript:;" onClick={logoClickHandler}>
              <img id="logo" role={role} src={logoSrc} alt={alt} />
            </a>
          )}
        </div>
      )}
    </>
  );
}
Logo.propTypes = {
  onLogoClick: PropTypes.func,
  logoExt: PropTypes.string,
};
